import React from 'react';
import './logo.css';

const Logo = () => {
  return (
    <div className="logo">
      <div className="container">
        <div className="ring"></div>
        <div className="ring"></div>
      </div>
    </div>
  );
};

export default Logo;
